/** Allowed roles for Place Modules */
export var PlaceDriverRole;
(function (PlaceDriverRole) {
    PlaceDriverRole[PlaceDriverRole["SSH"] = 0] = "SSH";
    PlaceDriverRole[PlaceDriverRole["Device"] = 1] = "Device";
    PlaceDriverRole[PlaceDriverRole["Service"] = 2] = "Service";
    PlaceDriverRole[PlaceDriverRole["Websocket"] = 3] = "Websocket";
    PlaceDriverRole[PlaceDriverRole["Logic"] = 99] = "Logic";
})(PlaceDriverRole || (PlaceDriverRole = {}));
